import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { Spinner, ContentWithToc } from '../../../../../common/index.jsx';
import { AppBarCMS } from '../../../../../basic/index.jsx';
import { routes } from '../../../../../../utils/helpers/ApiClient.jsx';
import { useGetWikiPageItemQuery } from '../../../../../../redux/services/wikiApi.jsx';
import { FontAwesomeIcon } from '../../../../../../utils/helpers/UtilityComponents.jsx';
import usePermission from '../../../../../../hooks/usePermission.jsx';
import dayjs from 'dayjs';
import { DATETIME_FORMAT_DATETIME } from '../../../../../../utils/helpers/CommonHelper.jsx';
import './PageDetail.sass';

const PageDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const canUpdate = usePermission('wiki-pages.update');

  const { data: wikiPage, isLoading } = useGetWikiPageItemQuery(id);

  useEffect(() => {
    document.title = `FRI.wiki - ${wikiPage?.title || t('Detail wiki stránky')}`;
  }, [t, wikiPage?.title]);

  if (isLoading || !wikiPage) {
    return <Spinner />;
  }

  const isUpdated =
    wikiPage.updated_at &&
    !dayjs(wikiPage.updated_at).isSame(wikiPage.created_at, 'minute');

  return (
    <>
      <AppBarCMS
        title={t('Detail wiki stránky')}
        backUrl={routes.cmsWikiPages}
        backUrlTooltip={t('FRI.wiki')}
        permissionsBasic={'wiki-pages'}
        mainActions={[
          canUpdate && {
            title: t('Upraviť'),
            onClick: () => navigate(`${routes.cmsWikiPageEdit}/${wikiPage.id}`),
          },
        ].filter(Boolean)}
      />

      <div className="wiki-detail">
        <header className="wiki-detail__header">
          {wikiPage.category_name && (
            <span className="wiki-detail__category">
              <FontAwesomeIcon icon={'folder-open'} />
              {wikiPage.category_name}
            </span>
          )}
          <h1 className="wiki-detail__title">{wikiPage.title}</h1>
          <div className="wiki-detail__meta">
            <span>
              <FontAwesomeIcon icon={'user'} />
              {wikiPage.author_name || '–'}
            </span>
            <span>
              <FontAwesomeIcon icon={'calendar-plus'} />
              {t('Vytvorené')}:{' '}
              {wikiPage.created_at
                ? dayjs(wikiPage.created_at).format(DATETIME_FORMAT_DATETIME)
                : '–'}
            </span>
            {isUpdated && (
              <span>
                <FontAwesomeIcon icon={'pen'} />
                {t('Upravené')}:{' '}
                {dayjs(wikiPage.updated_at).format(DATETIME_FORMAT_DATETIME)}
              </span>
            )}
          </div>
        </header>

        <ContentWithToc
          content={wikiPage.content}
          contentClassName="rich-content rich-content--steps add-icons-to-file-anchors"
          wrapperClassName="wiki-detail__content"
          headingIdPrefix="wiki-heading"
        />
      </div>
    </>
  );
};

export default PageDetail;
